import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import pt from 'vuetify/lib/locale/pt'
import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'
import preset from '@/@core/preset/preset'

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { pt, en, es },
    current: 'pt',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
